export const getOnlineStatus = (lastPingTime: string | null): boolean => {
  if (!lastPingTime) return false;

  const ONE_MINUT = 60000;
  const difference = new Date().getTime() - new Date(lastPingTime).getTime();
  if (difference < ONE_MINUT) return true;
  return false;
};
